import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';

import { environment } from 'src/environments/environment';

import { Company } from '../../companies/models/';
import { Subscription } from '../models/subscription.model';
import { BalanceInfo } from 'voxloud-types/dist/models';

@Injectable()
export class SubscriptionService {
  constructor(private http: HttpClient) { }

  public getSubscription(companyId): Observable<Subscription> {
    return this.http.get<Subscription>(
      `${environment.apiEndpoint}/api/v1/subscriptions/${companyId}`
    );
  }

  public setPaymentVerification(company: Company, value: boolean) {
    return this.http.put(
      `${environment.apiEndpoint}/api/v1/subscriptions/${company.companyId}/toggle-payment-verification-required`,
      { payment_verification_required: value }
    )
  }

  public getBillingInfo(companyId: any) {
    return this.http.get(`${environment.apiEndpoint}/api/v1/subscriptions/${companyId}/billing-info`);
  }

  public getPaymentInfo(companyId: number) {
    return this.http.get(`${environment.apiEndpoint}/api/v1/subscriptions/${companyId}/payment-method`);
  }

  public getCompanyCountry(subscription: Subscription) {
    const firstPlanWord = subscription.plan.id.split('-')[0];
    // we need to have a fallback for old Italian-only plans
    // e.g. start-annual-v3.
    // country code is expected to have 2 chars
    return firstPlanWord.length === 2 ? firstPlanWord : 'it';
  }

  public updateAntiFraudLock(companyId: number, lock: boolean) {
    return this.http.put(`${environment.apiEndpoint}/api/v1/subscriptions/${companyId}/toggle-fraud-prevention`, {
      fraud_prevention_enabled: lock
    });
  }

  public getBalanceInfo(billingAccountId: number): Observable<BalanceInfo[]> {
    return this.http.get<BalanceInfo[]>(`${environment.apiEndpoint}/api/v1/billing-accounts/${billingAccountId}/balances`);
  }
}
